import React, { SVGProps } from "react";

const Sim3Icon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width={props?.width || "145"}
      height={props?.height || "195"}
      viewBox="0 0 145 195"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M133.411 194.187H11.5892C5.1882 194.187 0 188.999 0 182.598V11.5892C0 5.18819 5.1882 0 11.5892 0H89.7491C92.8485 0 95.7458 1.21283 97.9693 3.36896L141.631 47.0307C143.787 49.1868 145 52.1515 145 55.2509V182.665C145 188.999 139.812 194.187 133.411 194.187Z"
        fill="#292929"
        fillOpacity="0.71"
      />
      <path
        d="M33.5 146.812L43.2917 156.604M33.5 146.812L23.7083 156.604M33.5 146.812V159.542M33.5 166.396C33.5 169.66 31.5417 176.187 23.7083 176.187"
        stroke="#FD9D0E"
        strokeWidth="2.9375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        opacity="0.4"
        x="24"
        y="45"
        width="80"
        height="80"
        fill="url(#pattern0_2_25)"
      />
      <defs>
        <pattern
          id="pattern0_2_25"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use href="#image0_2_25" transform="scale(0.015625)" />
        </pattern>
        <image
          id="image0_2_25"
          width="64"
          height="64"
          href="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};

export default Sim3Icon;
